import React, { useState } from "react";
import { SelectPicker } from "rsuite";
import { useNonDefaultModules } from "./WorkspaceFiltersSection";
import _ from "underscore";
import AppDrawer from "../AppDrawer";
import EditPrefillMenu from "components/CRM/EditPrefillMenu";
import { Button } from "reactstrap";

const PrefillPairsDrawer = ({
  open,
  onClose,
  selectedIndex,
  values,
  setValues,
  modulesMap,
}) => {
  const currentModule =
    modulesMap?.[values?.Prefills?.[selectedIndex]?.ModuleAPIName];

  const onChange = (newPrefills) => {
    setValues((prev) => ({
      ...prev,
      Prefills: prev.Prefills.map((p, i) => {
        if (i === selectedIndex) {
          return { ...p, Prefills: newPrefills };
        }
        return p;
      }),
    }));
  };

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle={
        <div className="d-flex">
          <span className="font-weight-500">Quick Create for&nbsp;</span>{" "}
          {currentModule?.Name}
        </div>
      }
      headerDescription="Added fields will be used in every quick create for this data source"
      headerOptions={
        <Button size="sm" onClick={onClose} color="primary">
          Close
        </Button>
      }
      bodyCSS="pt-3"
      body={
        <EditPrefillMenu
          module={currentModule ?? null}
          prefillPairs={values?.Prefills?.[selectedIndex]?.Prefills ?? []}
          onChange={onChange}
          toggleEditing={onClose}
          showVariables
          editOnly
        />
      }
    />
  );
};

const PrefillsHeader = () => {
  return (
    <>
      <h3 className="mb-0">Default Values</h3>
      <small>
        Add default values that will be enforced on record creation for specific
        data sources
      </small>
      <hr className="my-2" />
    </>
  );
};

const Prefill = ({ module, onEdit, onDelete }) => {
  return (
    <div className="border py-2 px-3 my-1 d-flex align-items-center border rounded bg-ultralight d-flex justify-content-between  font-weight-500">
      <div className="d-flex align-items-center">
        <i className="mdi mdi-database mr-2" style={{ fontSize: 22 }} />
        {module?.Name}
      </div>
      <div>
        <Button size="sm" className="btn-icon-only" outline onClick={onEdit}>
          <i className="mdi mdi-pencil" />
        </Button>
        <Button
          size="sm"
          className="btn-icon-only"
          color="danger"
          outline
          onClick={onDelete}
        >
          <i className="mdi mdi-close" />
        </Button>
      </div>
    </div>
  );
};

const WorkspacePrefillsSection = ({ values, setValues, useHeader = true }) => {
  const { nonDefaultModules, modulesMap } = useNonDefaultModules();
  const [selectedModuleIndex, setSelectedModuleIndex] = useState(-1);

  const handleSelect = (moduleAPIName) => {
    setValues((prev) => ({
      ...prev,
      Prefills: [
        ...prev.Prefills,
        { ModuleAPIName: moduleAPIName, Prefills: [] },
      ],
    }));
  };

  const handleDelete = (index) => {
    setValues((prev) => ({
      ...prev,
      Prefills: prev.Prefills.filter((_, i) => i !== index),
    }));
  };

  if (!nonDefaultModules.length) {
    return (
      <>
        {useHeader && <PrefillsHeader />}
        <div className="small border bg-ultralight rounded p-2 font-weight-500">
          You haven't created any custom data sources yet.
          <br /> You can come back and add filters after creating your own Data
          Sources
        </div>
      </>
    );
  }

  return (
    <>
      {useHeader && <PrefillsHeader />}
      <h4 className={useHeader ? "mt-3" : ""}>
        Select a data source you want to add Default Values for
      </h4>
      <SelectPicker
        value={null}
        data={nonDefaultModules.filter(
          (mod) => !_.findWhere(values.Prefills, { ModuleAPIName: mod.APIName })
        )}
        labelKey={"Name"}
        valueKey={"APIName"}
        block
        placeholder="Select a data source"
        onSelect={handleSelect}
      />
      {values?.Prefills?.map((prefill, index) => {
        const mod = modulesMap[prefill.ModuleAPIName];

        return (
          <Prefill
            key={prefill.ModuleAPIName}
            module={mod}
            prefill={prefill}
            index={index}
            setValues={setValues}
            onEdit={() => setSelectedModuleIndex(index)}
            onDelete={() => handleDelete(index)}
          />
        );
      })}
      {(values?.Prefills?.length === 0 || !!values?.Prefills === false) && (
        <div
          className="mt-3 bg-ultralight border rounded px-4 py-2"
          style={{ fontSize: 14 }}
        >
          No Data Sources have been selected.
        </div>
      )}
      <PrefillPairsDrawer
        open={selectedModuleIndex > -1}
        onClose={() => setSelectedModuleIndex(-1)}
        selectedIndex={selectedModuleIndex}
        values={values}
        setValues={setValues}
        modulesMap={modulesMap}
      />
    </>
  );
};

export default WorkspacePrefillsSection;
